var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2783 13.7878L10.0136 17.5106C10.3923 17.5106 10.5563 17.3479 10.7529 17.1526L12.5283 15.4559L16.2071 18.1499C16.8818 18.5259 17.3571 18.3279 17.5391 17.5292L19.9538 6.2143L19.9545 6.21363C20.1685 5.21628 19.5938 4.82627 18.9365 5.07094L4.7428 10.5051C3.77411 10.8811 3.78878 11.4211 4.57813 11.6658L8.20689 12.7945L16.6358 7.52033C17.0324 7.25766 17.3931 7.40299 17.0964 7.66567L10.2783 13.7878Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_215_7142",
    x1: 4,
    y1: 18.3337,
    x2: 20,
    y2: 18.3337,
    gradientUnits: ""
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: ""
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.f449b59a543e1ea08a839a3f4adcc0e7.svg";
export { ForwardRef as ReactComponent };